import React from 'react'

function Failurepage() {
  return (
    <div>Failurepage</div>
  )
}

export default Failurepage














